import React from "react";
import {
  ROUTE_ADMIN_DASHBOARD_AVERAGE_CHECK,
  ROUTE_ADMIN_DASHBOARD_METRICA,
  ROUTE_ADMIN_CATEGORIES,
  ROUTE_ADMIN_SUPPLIERS_ANALYZE_LOGIN,
  ROUTE_ADMIN_SUPPLIERS_REPORTS_LOGS,
  ROUTE_MOBILE_CATALOG_LIST,
  ROUTE_MOBILE_CATALOG_PRODUCTS,
  ROUTE_MOBILE_PROFILE,
  ROUTE_MOBILE_TRASH,
  ROUTE_ADMIN_PRODUCTS,
  ROUTE_ADMIN_SUPPLIERS_ANALYZE_SHOPS,
  ROUTE_ADMIN_PROMO,
  ROUTE_SHOPS_MAIN,
  ROUTE_REGISTRATION,
  ROUTE_RESTORE,
  ROUTE_REGISTRATION_COMPLETE,
  ROUTE_SETTINGS_APP,
  ROUTE_SETTINGS_WEB,
  ROUTE_SUPPLIER_LIST,
  ROUTE_POLLS,
  ROUTE_ADMIN_SUPPLIERS_ANALYZE_POLLS,
  ROUTE_ADMIN_ORDERS,
  ROUTE_SUPPLIER_INFO,
  ROUTE_TABLE_LAVKA,
  ROUTE_ADMIN_CONTRACTS,
  ROUTE_TAPLINK,
  ROUTE_SBER_BENEFICIARY_LIST,
  ROUTE_ADMIN_SPECIFICATION,
  ROUTE_ADMIN_PARTNER_SUPPLIER,
  ROUTE_ADMIN_SUPPLIER_PROFILE,
  ROUTE_ADMIN_SUPPLIER_TRADERS,
  ROUTE_ADMIN_DISCOUNT,
  ROUTE_SBER_MOMENT_PAY_BACK,
  ROUTE_SBER_MOMENT_PAY,
  ROUTE_BONUS_MYBONUS,
  ROUTE_BONUS_CONSTRUCTOR,
  ROUTE_ADMIN_SUPPLIERS_REPORTS_DINAMICA_PRODAJ,
  ROUTE_DISCOUNT_USERS,
  ROUTE_DISCOUNT_CERT,
  ROUTE_DISCOUNT_SUPPLIERS,
  ROUTE_DISCOUNT_SHOPS,
  ROUTE_DISCOUNT_UNIQUE_SHOPS,
  ROUTE_ADMIN_PROMO_PUSH_NOTIFY,
  ROUTE_ADMIN_SBER_BENEFICIARY_REGISTRY,
  ROUTE_ADMIN_SBER_ORDER_PAYMENTS,
} from "./../constants/appRoutes";
import {
  ROUTE_ADMIN,
  ROUTE_ADMIN_OBJECT,
  ROUTE_ADMIN_SHOPS_SUPPLIERS,
  ROUTE_ADMIN_SUPPLIERS_REPORTS_DAY,
  ROUTE_ADMIN_SUPPLIERS_REPORTS_ORDERS,
  ROUTE_ADMIN_TRADERS,
  ROUTE_HOME,
  ROUTE_LAVKA,
  ROUTE_LOGIN,
  ROUTE_MYORDERS,
  ROUTE_NOTIFY,
  ROUTE_ADMIN_CATEGORIES_TYPE_RETAILY,
  ROUTE_ADMIN_PRODUCTS_TYPE_RETAILY,
} from "../constants/appRoutes";

const SupplierReportDynamicaProdaj = React.lazy(
  () => import("../components/Admin/Reports/SupplierReportDynamicaProdaj"),
);

const BlockSupplierContainer = React.lazy(
  () => import("../components/Home/Main/BlockSupplier/BlockSupplierContainer"),
);
const AdminContainer = React.lazy(
  () => import("../components/Admin/AdminContainer"),
);
const ShopsSuppliersContainer = React.lazy(
  () => import("../components/Admin/ShopsSuppliers/ShopsSuppliersContainer"),
);
const TradersContainer = React.lazy(
  () => import("../components/Admin/TradersNew/TradersContainer"),
);
const BdrObjectContainer = React.lazy(
  () => import("../components/common/Object/BdrObjectContainer"),
);
const HomeContainer = React.lazy(
  () => import("../components/Home/HomeContainer"),
);
const MainContainer = React.lazy(
  () => import("../components/Home/Main/MainContainer"),
);
const LavkaContainer = React.lazy(
  () => import("../components/Home/Lavka/LavkaContainer"),
);
const LoginContainer = React.lazy(
  () => import("../components/Login/LoginContainer"),
);
const MyOrdersContainer = React.lazy(
  () => import("../components/Home/Order/MyOrders/MyOrdersContainer"),
);
const SuppliersReport = React.lazy(
  () => import("../components/Admin/Reports/SuppliersReport"),
);
const SuppliersReportOrg = React.lazy(
  () => import("../components/Admin/Reports/SuppliersReportOrg"),
);
const SuppliersReportShops = React.lazy(
  () => import("../components/Admin/Reports/SuppliersReportShops"),
);
const AnalyzeContainer = React.lazy(
  () => import("../components/Admin/Analyze/AnalyzeContainer"),
);
const AdminSpecification = React.lazy(
  () => import("../components/Admin/Specification/SpecificationTable"),
);
const CatalogMobileContainer = React.lazy(
  () => import("../components/Home/Drawer/Catalog/CatalogMobileContainer"),
);
const TrashDrawer = React.lazy(
  () => import("../components/Home/Drawer/Trash/TrashDrawer"),
);
const ProfileContainer = React.lazy(
  () => import("../components/Home/Profile/ProfileContainer"),
);
const SuppliersReportLogs = React.lazy(
  () => import("../components/Admin/Reports/SuppliersReportLogs"),
);
const CategoriesContainer = React.lazy(
  () => import("../components/Admin/Categories/CategoriesContainer"),
);
const ProductsContainer = React.lazy(
  () => import("../components/Admin/Products/ProductsContainer"),
);
const OrdersContainer = React.lazy(
  () => import("../components/Admin/Orders/OrdersContainer"),
);
const Promo = React.lazy(() => import("../components/Admin/Promo/Promo"));
const ShopsMain = React.lazy(
  () => import("../components/Home/Main/Shops/ShopsMain"),
);
const RegistrationContainer = React.lazy(
  () => import("../components/Login/Registration/RegistrationContainer"),
);
const RegistrationComplete = React.lazy(
  () => import("../components/Login/Registration/RegistrationComplete"),
);
const SettingsContainer = React.lazy(
  () => import("../components/Settings/SettingsContainer"),
);
const RestoreContainer = React.lazy(
  () => import("../components/Login/Restore/RestoreContainer"),
);
const PollsAdminContainer = React.lazy(
  () => import("../components/Admin/Polls/PollsContainer"),
);
const PollsContainer = React.lazy(
  () => import("../components/Polls/PollsContainer"),
);
const AdminMainContainer = React.lazy(
  () => import("../components/Admin/Main/AdminMainContainer"),
);
const SupplierInfoMobile = React.lazy(
  () => import("../components/Home/Main/Supplier/SupplierInfoMobile"),
);
const TableLavkaContainer = React.lazy(
  () => import("../components/Home/Lavka/TableLavka/TableLavkaContainer"),
);
const ContractsContainer = React.lazy(
  () => import("../components/Admin/Contracts/ContractsContainer"),
);
const DashboardMetricaContainer = React.lazy(
  () =>
    import("../components/Admin/Dashboard/DashboardMetrica/DashboardMetricaContainer"),
);
const DashboardAverageCheckContainer = React.lazy(
  () =>
    import("../components/Admin/Dashboard/DashboardAverageCheck/DashboardAverageCheckContainer"),
);
const CategoriesRetailyContainer = React.lazy(
  () =>
    import("../components/Admin/CategoriesProductsRetaily/CategoriesRetailyContainer"),
);
const ProductsRetailyContainer = React.lazy(
  () => import("../components/Admin/ProductsRetaily/ProductsRetailyContainer"),
);

const Taplink = React.lazy(() => import("../components/Home/Taplink/Taplink"));
const Notify = React.lazy(
  () => import("../components/Home/OtherPage/Notify"),
);

const BeneficiarsContainer = React.lazy(
  () => import("../components/Admin/Sber/BeneficiarsContainer"),
);

const BeneficiarsAccess = React.lazy(
  () => import("../components/Admin/Sber/BeneficiaryAccess"),
);

const BeneficiarsRegistry = React.lazy(
  () => import("../components/Admin/Sber/BeneficiaryRegistry"),
);

const OrderPayments = React.lazy(
  () => import("../components/Admin/Sber/OrderPayments"),
);

const PartnersSuppliersContainer = React.lazy(
  () =>
    import("../components/Admin/Partners/PartnersSuppliers/PartnersSuppliersContainer"),
);

const SupplierProfile = React.lazy(
  () => import("../components/Admin/Suppliers/SuppliersContainer"),
);

const SupplierTraders = React.lazy(
  () =>
    import("../components/Admin/Traders/TradersSupplier/TradersSupplierContainer"),
);

const SberMomentPayBack = React.lazy(
  () => import("../components/SberPay/MomentPay/MomentPayBack"),
);

const BonusMyBonus = React.lazy(() => import("../components/Bonus/MyBonus"));

const BonusConstructor = React.lazy(
  () => import("../components/Admin/Bonus/BonusConstructor"),
);

const DiscountUsers = React.lazy(
  () => import("../components/Admin/Discount/DiscountUsers"),
);

const DiscountCert = React.lazy(
  () => import("../components/Admin/Discount/DiscountCert"),
);
const DiscountSuppliers = React.lazy(
  () => import("../components/Admin/Discount/DiscountSuppliers"),
);
const DiscountShops = React.lazy(
  () => import("../components/Admin/Discount/DiscountShops"),
);
const DiscountUniqueShops = React.lazy(
  () => import("../components/Admin/Discount/DiscountUniqueShops"),
);

const PushNotify = React.lazy(() => import("../components/Admin/Promo/Push"));

export interface AppRoute {
  path: string;
  component: any;
  exact: boolean;
}

export const AppRoutes: AppRoute[] = [
  {
    path: ROUTE_ADMIN,
    component: AdminContainer,
    exact: false,
  },
  {
    path: ROUTE_LOGIN,
    component: LoginContainer,
    exact: false,
  },
  {
    path: ROUTE_REGISTRATION,
    component: RegistrationContainer,
    exact: false,
  },
  {
    path: ROUTE_RESTORE,
    component: RestoreContainer,
    exact: false,
  },
  {
    path: ROUTE_SETTINGS_APP,
    component: SettingsContainer,
    exact: false,
  },
  {
    path: ROUTE_SUPPLIER_INFO,
    component: SupplierInfoMobile,
    exact: false,
  },
  {
    path: ROUTE_REGISTRATION_COMPLETE,
    component: RegistrationComplete,
    exact: false,
  },
  {
    path: ROUTE_POLLS,
    component: PollsContainer,
    exact: false,
  },
  {
    path: ROUTE_TAPLINK,
    component: Taplink,
    exact: false,
  },
  {
    path: ROUTE_SBER_MOMENT_PAY_BACK,
    component: SberMomentPayBack,
    exact: true,
  },
  {
    path: ROUTE_SBER_MOMENT_PAY,
    component: SberMomentPayBack,
    exact: true,
  },
  {
    path: ROUTE_HOME,
    component: HomeContainer,
    exact: false,
  },
];

export const adminRoutes: AppRoute[] = [
  {
    path: ROUTE_ADMIN_PROMO_PUSH_NOTIFY,
    component: PushNotify,
    exact: true,
  },
  {
    path: ROUTE_DISCOUNT_SHOPS,
    component: DiscountShops,
    exact: true,
  },
  {
    path: ROUTE_DISCOUNT_UNIQUE_SHOPS,
    component: DiscountUniqueShops,
    exact: true,
  },
  {
    path: ROUTE_DISCOUNT_USERS,
    component: DiscountUsers,
    exact: true,
  },
  {
    path: ROUTE_DISCOUNT_CERT,
    component: DiscountCert,
    exact: true,
  },
  {
    path: ROUTE_DISCOUNT_SUPPLIERS,
    component: DiscountSuppliers,
    exact: true,
  },
  {
    path: ROUTE_ADMIN_SUPPLIER_TRADERS,
    component: SupplierTraders,
    exact: true,
  },
  {
    path: ROUTE_ADMIN_PARTNER_SUPPLIER,
    component: PartnersSuppliersContainer,
    exact: true,
  },
  {
    path: ROUTE_ADMIN_SUPPLIER_PROFILE,
    component: SupplierProfile,
    exact: true,
  },
  {
    path: ROUTE_ADMIN_SPECIFICATION,
    component: AdminSpecification,
    exact: true,
  },
  {
    path: ROUTE_ADMIN_OBJECT,
    component: BdrObjectContainer,
    exact: true,
  },
  {
    path: ROUTE_ADMIN_TRADERS,
    component: TradersContainer,
    exact: true,
  },
  {
    path: ROUTE_ADMIN_CATEGORIES,
    component: CategoriesContainer,
    exact: true,
  },
  {
    path: ROUTE_ADMIN_PRODUCTS,
    component: ProductsContainer,
    exact: true,
  },
  {
    path: ROUTE_ADMIN_SHOPS_SUPPLIERS,
    component: ShopsSuppliersContainer,
    exact: true,
  },
  {
    path: ROUTE_ADMIN_ORDERS,
    component: OrdersContainer,
    exact: true,
  },
  {
    path: ROUTE_ADMIN_CONTRACTS,
    component: ContractsContainer,
    exact: true,
  },
  {
    path: ROUTE_ADMIN_SUPPLIERS_REPORTS_DAY,
    component: SuppliersReport,
    exact: true,
  },

  {
    path: ROUTE_ADMIN_SUPPLIERS_REPORTS_DINAMICA_PRODAJ,
    component: SupplierReportDynamicaProdaj,
    exact: true,
  },
  {
    path: ROUTE_ADMIN_SUPPLIERS_REPORTS_ORDERS,
    component: SuppliersReportOrg,
    exact: true,
  },
  {
    path: ROUTE_ADMIN_SUPPLIERS_ANALYZE_SHOPS,
    component: SuppliersReportShops,
    exact: true,
  },
  {
    path: ROUTE_ADMIN_SUPPLIERS_ANALYZE_POLLS,
    component: PollsAdminContainer,
    exact: true,
  },
  {
    path: ROUTE_ADMIN_SUPPLIERS_REPORTS_LOGS,
    component: SuppliersReportLogs,
    exact: true,
  },
  {
    path: ROUTE_ADMIN_SUPPLIERS_ANALYZE_LOGIN,
    component: AnalyzeContainer,
    exact: true,
  },
  {
    path: ROUTE_ADMIN_PROMO,
    component: Promo,
    exact: true,
  },
  {
    path: ROUTE_ADMIN_DASHBOARD_METRICA,
    component: DashboardMetricaContainer,
    exact: true,
  },
  {
    path: ROUTE_ADMIN_DASHBOARD_AVERAGE_CHECK,
    component: DashboardAverageCheckContainer,
    exact: true,
  },
  {
    path: ROUTE_ADMIN_CATEGORIES_TYPE_RETAILY,
    component: CategoriesRetailyContainer,
    exact: true,
  },
  {
    path: ROUTE_ADMIN_PRODUCTS_TYPE_RETAILY,
    component: ProductsRetailyContainer,
    exact: true,
  },
  {
    path: ROUTE_SBER_BENEFICIARY_LIST,
    component: BeneficiarsContainer,
    exact: true,
  },
  {
    path: ROUTE_ADMIN_SBER_BENEFICIARY_REGISTRY,
    component: BeneficiarsRegistry,
    exact: true,
  },
  {
    path: ROUTE_ADMIN_SBER_ORDER_PAYMENTS,
    component: OrderPayments,
    exact: true,
  },
  {
    path: ROUTE_BONUS_CONSTRUCTOR,
    component: BonusConstructor,
    exact: false,
  },
  {
    path: ROUTE_ADMIN,
    component: AdminMainContainer,
    exact: false,
  },
];

export const homeRoutes: AppRoute[] = [
  {
    path: ROUTE_HOME,
    component: MainContainer,
    exact: true,
  },
  {
    path: ROUTE_MYORDERS,
    component: MyOrdersContainer,
    exact: false,
  },
  {
    path: ROUTE_NOTIFY,
    component: Notify,
    exact: true,
  },
  {
    path: ROUTE_SUPPLIER_LIST,
    component: BlockSupplierContainer,
    exact: true,
  },
  {
    path: ROUTE_SHOPS_MAIN,
    component: ShopsMain,
    exact: true,
  },
  {
    path: ROUTE_LAVKA,
    component: LavkaContainer,
    exact: true,
  },
  {
    path: ROUTE_TABLE_LAVKA,
    component: TableLavkaContainer,
    exact: true,
  },
  {
    path: ROUTE_MOBILE_CATALOG_LIST,
    component: CatalogMobileContainer,
    exact: true,
  },
  {
    path: ROUTE_MOBILE_CATALOG_PRODUCTS,
    component: CatalogMobileContainer,
    exact: true,
  },
  {
    path: ROUTE_MOBILE_TRASH,
    component: TrashDrawer,
    exact: true,
  },
  {
    path: ROUTE_MOBILE_PROFILE,
    component: ProfileContainer,
    exact: true,
  },
  {
    path: ROUTE_BONUS_MYBONUS,
    component: BonusMyBonus,
    exact: true,
  },
  {
    path: ROUTE_SETTINGS_WEB,
    component: SettingsContainer,
    exact: false,
  },
];
